import { API_RESOURCE } from '@/constants/api.constant'
import { useCrud } from '@/hooks/useCrud'
import { createOptions } from '@/utils/arrayHelper'
import { camelToWords } from '@/utils/stringHelper'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import RuleService from './rule.service'

//TODO: Test
export const useRule = () => {
  const service = new RuleService()
  const baseCrud = useCrud(API_RESOURCE.RULE, service)

  const queryClient = useQueryClient()

  const useUploadRules = () => {
    return useMutation({
      mutationFn: service.uploadRule,
      onSuccess: (res) => {
        toast.info(`Successfully Upload  ${camelToWords(API_RESOURCE.RULE)}`)

        queryClient.invalidateQueries(baseCrud.queryKey.lists())
      },
    })
  }

  const useRuleOptions = ({
    labelKey = 'name',
    valueKey = '_id',
    withNilOption = false,
    status = 'active',
    ...rest
  }) => {
    return useQuery({
      queryKey: [...baseCrud.queryKey.list({ page: 1, pageSize: 0, filters: { status: status, ...rest } })],
      queryFn: () => service.fetchAll({ page: 1, pageSize: 0, filters: { status: status, ...rest } }),
      placeholderData: [],
      select: (data) => createOptions(data?.data, labelKey, valueKey, withNilOption),
    })
  }

  return {
    //Base CRUD
    useFetchAllRules: baseCrud.useFetchAll,
    useFetchRule: baseCrud.useFetchOne,
    useCreateRule: baseCrud.useCreate,
    useUpdateRule: baseCrud.useUpdate,
    useRemoveRule: baseCrud.useRemove,

    //Extra
    useUploadRules,
  }
}
